import { Grid, Typography } from "@mui/material";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const Qualification = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={6}
    sx={{
      mb: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Qualifizierung
    </Typography>
    <Typography variant="body1" component="p">
      {appointment.participantQualification}
    </Typography>
  </Grid>
);

export default Qualification;
